import actionTypes from './actionTypes'

const playgroundActions = {
	openNearpodPickerModal(pickerType) {
		return {
			type: actionTypes.PLAYGROUND_NEARPOD_PICKER_MODAL_OPEN,
			pickerType,
		}
	},

	nearpodPickerPick(pickerType, pick) {
		return {
			type: actionTypes.PLAYGROUND_NEARPOD_PICKER_PICK,
			pickerType,
			pick,
		}
	},

	nearpodPickerFileError() {
		return {
			type: actionTypes.PLAYGROUND_NEARPOD_PICKER_FILE_ERROR,
		}
	},

	nearpodPickerCancel() {
		return {
			type: actionTypes.PLAYGROUND_NEARPOD_PICKER_CANCEL,
		}
	},
}

export default playgroundActions
